import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { IGetLanguages, IItemForGetShortInfo } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getLanguages } from 'backend/additionalInformation';
import { useTranslation } from 'react-i18next';

interface IDefaultLanguageSelect {
	setCustomerDefaultLanguage: (value: Nullable<string>) => void;
	setFetchedLanguages: (value: IItemForGetShortInfo[]) => void;
}

const DefaultLanguageSelect: React.FC<IDefaultLanguageSelect> = ({
	setCustomerDefaultLanguage,
	setFetchedLanguages,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetLanguages, null>(getLanguages);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	useEffect(() => {
		response && setFetchedLanguages(response.data.languages);
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectDefaultLanguage') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.languages.map((el) => ({
				id: el.id,
				name: tForm(el.name),
			})) || []
		);
	}, [response, tForm]);

	return (
		<FormSelect
			testId="DefaultLanguageSelect"
			name="IDSelectedCustomerDefaultLanguage"
			label="defaultLanguageLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setCustomerDefaultLanguage}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DefaultLanguageSelect);
